import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'

import Header from './Header'
import Footer from './Footer'
import Clients from './Clients'
import WhyUseUs from './WhyUseUs'
import WhatWeDo from './WhatWeDo'
import LunchMadeSimple from './LunchMadeSimple'
import LunchTeamMainPresentation from './LunchTeamMainPresentation'
import RegisterCompany from './RegisterCompany'
import queryString from 'utils/queryString'
import { setReferalFriendCode, setLinkCode } from 'actions/SignUp'
import { toggleRegisterCompany } from 'actions/Landing'
import isMobile from 'ismobilejs'
import './landing.scss'

class LandingBuilder extends Component {

  constructor(props) {
    super(props);
    this.howItWorksElement = null
    this.whatWeDoElement = null
    this.ourClientsElement = null
    this.whyUseUsElement = null
  }

  componentDidMount() {
    this.onHandeReferralFriend()
    this.onHandleLinkCode()
  }

  onHandeReferralFriend = () => {
    const values = queryString.parse(this.props.location.search)
    if (values.isReferalLink) {
      var combinedToken = values.combinedToken.substr(0, values.combinedToken.indexOf('+'));
      this.props.onSetReferalFriendCode(combinedToken)
    }
  }

  onHandleLinkCode = () => {
    const values = queryString.parse(this.props.location.search)
    if (values.isCodeLink) {
      var code = values.code
      this.props.onSetLinkCode(code)
    }
  }

  componentDidUpdate() {
    if (this.props.goToSignup) {
      this.props.history.push('/Signup')
    }
  }

  onHandleHowItWorks = () => {
    const domNode = ReactDOM.findDOMNode(this.howItWorksElement)
    domNode.scrollIntoView()
  }

  onHandleWhatWeDo = () => {
    const domNode = ReactDOM.findDOMNode(this.whatWeDoElement)
    domNode.scrollIntoView()
  }

  onHandleOurClients = () => {
    const domNode = ReactDOM.findDOMNode(this.ourClientsElement)
    domNode.scrollIntoView()
  }

  onHandleWhyUseUs = () => {
    const domNode = ReactDOM.findDOMNode(this.whyUseUsElement)
    domNode.scrollIntoView()
  }

  onHandleFindOutMore = () => {
    if (isMobile.any) {
      this.props.onToggleRegisterCompany(true)
    } else {
      window.LC_API.open_mobile_window()
    }
  }


  render() {
    return (
      <div className="home">
        <Header handleHowItWorks={this.onHandleHowItWorks}
          handleWhatWeDo={this.onHandleWhatWeDo}
          handleOurClients={this.onHandleOurClients}
          preLogin={this.props.preLogin}
          handleWhyUseUs={this.onHandleWhyUseUs} />
        <LunchTeamMainPresentation />
        <RegisterCompany />
        <WhatWeDo whatWeDoRef={el => this.whatWeDoElement = el}
          HandleFindOutMore={this.onHandleFindOutMore} />
        <LunchMadeSimple howItWorksRef={el => this.howItWorksElement = el}
          HandleFindOutMore={this.onHandleFindOutMore} />
        <WhyUseUs whyUseUsRef={el => this.whyUseUsElement = el}
          HandleFindOutMore={this.onHandleFindOutMore} />
        <Clients ourClientsRef={el => this.ourClientsElement = el}
          HandleFindOutMore={this.onHandleFindOutMore} />
        <Footer handleHowItWorks={this.onHandleHowItWorks}
          handleWhatWeDo={this.onHandleWhatWeDo}
          handleOurClients={this.onHandleOurClients}
          handleWhyUseUs={this.onHandleWhyUseUs} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    goToSignup: state.signupReducer.goToSignup,
    preLogin: state.signupReducer.preLogin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    onSetReferalFriendCode: (combinedToken) => dispatch(setReferalFriendCode(combinedToken)),
    onSetLinkCode: (code) => dispatch(setLinkCode(code)),
    onToggleRegisterCompany: (toggle) => dispatch(toggleRegisterCompany(toggle))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(LandingBuilder)



// WEBPACK FOOTER //
// ./src/containers/Landing/index.js